module.exports = __webpack_public_path__ + "img/64e2addd9ec65d27b37355b59a138cd1.svg";